import React, { useState } from 'react';

const VerificacionPage = ({ setCurrentPage }) => {
    const [code, setCode] = useState(['', '', '', '']);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
                <h2 className="text-2xl font-bold mb-4">Verificación de Cuenta</h2>
                <p className="mb-4 text-gray-600">Ingresa el código de 4 dígitos</p>
                <div className="flex gap-2 justify-center mb-4">
                    {code.map((digit, idx) => (
                        <input
                            key={idx}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => {
                                const newCode = [...code];
                                newCode[idx] = e.target.value;
                                setCode(newCode);
                            }}
                            className="w-12 h-12 text-center text-xl border rounded"
                        />
                    ))}
                </div>
                <button
                    onClick={() => alert('Funcionalidad pendiente')}
                    className="w-full bg-blue-900 text-white py-2 rounded hover:bg-blue-800"
                >
                    Verificar
                </button>
                <button
                    onClick={() => setCurrentPage('login')}
                    className="w-full mt-2 text-blue-600 hover:underline"
                >
                    Volver al login
                </button>
            </div>
        </div>
    );
};

export default VerificacionPage;
